import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Card } from '../card';
import { NotificationCard } from '../notification-card';
import { Paragraph } from '../paragraph';
import { ScreenReaderOnly } from '../screen-reader-only';
import { descriptionStaticStyle, titleStaticStyle, toastStaticStyle, } from './styles';
function CardInternal({ description, onClose, size, title, variant, }) {
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return _jsx(ScreenReaderOnly, { children: "Success:" });
            case 'warning':
                return _jsx(ScreenReaderOnly, { children: "Warning:" });
            case 'error':
                return _jsx(ScreenReaderOnly, { children: "Error:" });
            default:
                return null;
        }
    }
    return (_jsxs(NotificationCard, Object.assign({ closable: true, css: toastStaticStyle }, { onClose, size, variant }, { children: [_jsxs(Card.Header, Object.assign({ as: "h2", css: titleStaticStyle, size: size }, { children: [renderAnnouncement(), title] })), description != null && (_jsx(Paragraph, Object.assign({ css: descriptionStaticStyle, size: size, variant: "secondary" }, { children: description })))] })));
}
export default CardInternal;
